import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedProject: '',
  projectType: '',
  selectedType: '',
  selectedCategory: '',
  selectedDueDate: '',
  selectedOwner: '',
}

export const rfxFilterValuesSlice = createSlice({
  name: 'set-rfx-filter-values',
  initialState,
  reducers: {
    setSelectedProject: (state, action) => {
      state.selectedProject = action.payload
    },
    setProjectType: (state, action) => {
      state.projectType = action.payload
    },
    setSelectedType: (state, action) => {
      state.selectedType = action.payload
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload
    },
    setSelectedDueDate: (state, action) => {
      state.selectedDueDate = action.payload
    },
    setSelectedOwner: (state, action) => {
      state.selectedOwner = action.payload
    },
  },
})

export const {
  setSelectedProject,
  setProjectType,
  setSelectedType,
  setSelectedCategory,
  setSelectedDueDate,
  setSelectedOwner,
} = rfxFilterValuesSlice.actions

export default rfxFilterValuesSlice.reducer
